function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this),
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll(
      "button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)",
    ).forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent)
      elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

function setDisclosurePanelState(button, panel, expanded, animate = true) {
  button.setAttribute("aria-expanded", expanded.toString());
  button.closest(".menu-section")?.classList.toggle("opened", expanded);

  const indicator = button.querySelector(".menu-section__active");
  if (indicator) indicator.textContent = expanded ? "−" : "+";

  panel.setAttribute("aria-hidden", (!expanded).toString());
  panel.toggleAttribute("inert", !expanded);

  if (expanded) {
    panel.hidden = false;
    if (!animate) {
      panel.style.height = `${panel.scrollHeight}px`;
      return;
    }

    panel.style.height = "0px";
    window.requestAnimationFrame(() => {
      if (button.getAttribute("aria-expanded") === "true") {
        panel.style.height = `${panel.scrollHeight}px`;
      }
    });
    return;
  }

  panel.style.height = "0px";
  if (!animate || panel.hidden) {
    panel.hidden = true;
    return;
  }

  const hideCollapsedPanel = () => {
    if (button.getAttribute("aria-expanded") === "false") panel.hidden = true;
  };
  const onTransitionEnd = (event) => {
    if (event.target !== panel) return;
    panel.removeEventListener("transitionend", onTransitionEnd);
    hideCollapsedPanel();
  };

  panel.addEventListener("transitionend", onTransitionEnd);
  window.setTimeout(() => {
    panel.removeEventListener("transitionend", onTransitionEnd);
    hideCollapsedPanel();
  }, 400);
}

class MenuDrawerItem extends HTMLElement {
  connectedCallback() {
    if (this.dataset.disclosuresInitialized === "true") return;

    this.dataset.disclosuresInitialized = "true";
    this.disclosureButtons = Array.from(
      this.querySelectorAll("[data-menu-disclosure]"),
    );

    this.disclosureButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const willExpand = button.getAttribute("aria-expanded") !== "true";

        this.disclosureButtons.forEach((otherButton) => {
          if (otherButton !== button) this.setDisclosure(otherButton, false);
        });
        this.setDisclosure(button, willExpand);
      });
    });
  }

  setDisclosure(button, expanded) {
    const panel = document.getElementById(button.getAttribute("aria-controls"));
    if (!panel) return;

    setDisclosurePanelState(button, panel, expanded);
    const menu = this.querySelector(".menu-drawer__menu.has-submenu");
    if (menu) {
      menu.classList.toggle(
        "opened",
        this.disclosureButtons.some(
          (disclosure) => disclosure.getAttribute("aria-expanded") === "true",
        ),
      );
    }
  }

  closeAllDisclosures() {
    this.disclosureButtons.forEach((button) =>
      this.setDisclosure(button, false),
    );
  }
}

customElements.define("list-drawer-item", MenuDrawerItem);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();

    this.autoplayObserver = null;
    this.autoplayIsIntersecting = false;
    this.poster = null;
    this.idleCallbackId = null;
    this.timeoutId = null;
    this.autoplayDelayId = null;
    this.pageLoadHandler = null;
    this.reduceMotionQuery = null;
    this.hls = null;
    this.hlsReadyHandler = null;
    this.hlsReadyTimeoutId = null;
    this.playbackToggle = null;
    this.activeVideo = null;
    this.videoFrameCallbackId = null;
    this.userPaused = false;

    this.handlePosterClick = this.handlePosterClick.bind(this);
    this.handlePlaybackToggle = this.handlePlaybackToggle.bind(this);
    this.handleVideoStateChange = this.handleVideoStateChange.bind(this);
    this.handleReducedMotionChange =
      this.handleReducedMotionChange.bind(this);
  }

  connectedCallback() {
    this.initialize();

    if (!this.poster) {
      queueMicrotask(() => this.initialize());
    }
  }

  initialize() {
    if (!this.isConnected) return;

    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    if (poster !== this.poster) {
      this.poster?.removeEventListener("click", this.handlePosterClick);
      this.poster = poster;
      poster.addEventListener("click", this.handlePosterClick);
    }

    const playbackToggle = this.querySelector("[data-video-playback-toggle]");
    if (playbackToggle !== this.playbackToggle) {
      this.playbackToggle?.removeEventListener(
        "click",
        this.handlePlaybackToggle,
      );
      this.playbackToggle = playbackToggle;
      this.playbackToggle?.addEventListener(
        "click",
        this.handlePlaybackToggle,
      );
      this.syncPlaybackControl();
    }

    if (!poster.hasAttribute("autoplay")) return;

    if (!this.reduceMotionQuery) {
      this.reduceMotionQuery = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      );
      this.reduceMotionQuery.addEventListener(
        "change",
        this.handleReducedMotionChange,
      );
    }

    this.updateAutoplaySuppressedState();

    if (
      this.hasPriorityAutoplay() &&
      this.isAutoplayAllowed() &&
      typeof IntersectionObserver !== "function"
    ) {
      this.loadContent(false);
      return;
    }

    this.observeForAutoplay();
  }

  handlePosterClick() {
    this.userPaused = false;
    const existingVideo = this.querySelector("video");

    if (this.hasAttribute("loaded") && existingVideo) {
      existingVideo.play().catch(() => {});
      return;
    }

    this.loadContent(true);
  }

  handlePlaybackToggle() {
    const video = this.activeVideo || this.querySelector("video");
    if (!video) return;

    if (video.paused) {
      this.userPaused = false;
      video.play().catch(() => this.syncPlaybackControl());
      return;
    }

    this.userPaused = true;
    video.pause();
  }

  setActiveVideo(video) {
    if (video === this.activeVideo) return;

    if (this.videoFrameCallbackId !== null) {
      this.activeVideo?.cancelVideoFrameCallback?.(this.videoFrameCallbackId);
      this.videoFrameCallbackId = null;
    }

    for (const eventName of ["play", "playing", "pause", "ended"]) {
      this.activeVideo?.removeEventListener(
        eventName,
        this.handleVideoStateChange,
      );
    }

    this.activeVideo = video;
    this.removeAttribute("data-video-ready");

    for (const eventName of ["play", "playing", "pause", "ended"]) {
      this.activeVideo?.addEventListener(
        eventName,
        this.handleVideoStateChange,
      );
    }

    this.syncPlaybackControl();
  }

  handleVideoStateChange(event) {
    const video = this.activeVideo;
    const isPlaying = Boolean(video && !video.paused && video.readyState >= 3);
    this.toggleAttribute("data-playing", isPlaying);
    if (isPlaying) {
      this.removeAttribute("data-autoplay-suppressed");
    }

    // `play` only signals intent; the first frame may still be downloading.
    // Keep the existing poster until playback can actually paint a frame.
    if (
      event.type === "playing" &&
      !this.hasAttribute("data-video-ready") &&
      this.videoFrameCallbackId === null
    ) {
      const revealVideo = () => {
        this.videoFrameCallbackId = null;
        if (this.activeVideo !== video) return;

        this.setAttribute("data-video-ready", "");
        this.removeAttribute("data-autoplay-pending");
      };

      if (typeof video.requestVideoFrameCallback === "function") {
        this.videoFrameCallbackId = video.requestVideoFrameCallback(revealVideo);
      } else {
        revealVideo();
      }
    }
    this.syncPlaybackControl();
  }

  syncPlaybackControl() {
    if (!this.playbackToggle) return;

    const video = this.activeVideo || this.querySelector("video");
    const hasLoadedVideo = this.hasAttribute("loaded") && Boolean(video);
    const isPaused = !video || video.paused;

    this.playbackToggle.hidden = !hasLoadedVideo;
    this.playbackToggle.dataset.playbackState = isPaused ? "paused" : "playing";
    this.playbackToggle.setAttribute(
      "aria-label",
      isPaused ? "Play video" : "Pause video",
    );
  }

  handleReducedMotionChange(event) {
    this.cancelScheduledAutoplay();
    this.updateAutoplaySuppressedState();

    if (event.matches) {
      this.querySelector("video")?.pause();
      return;
    }

    this.autoplayObserver?.disconnect();
    this.autoplayObserver = null;
    this.autoplayIsIntersecting = false;
    this.observeForAutoplay();
  }

  isAutoplayAllowed() {
    return (
      !this.reduceMotionQuery?.matches &&
      !navigator.connection?.saveData &&
      !this.hasAttribute("data-defer-autoplay")
    );
  }

  hasPriorityAutoplay() {
    return this.hasAttribute("data-priority-autoplay");
  }

  updateAutoplaySuppressedState() {
    this.toggleAttribute(
      "data-autoplay-suppressed",
      !this.isAutoplayAllowed(),
    );
  }

  isActiveCarouselSlide() {
    if (!this.hasAttribute("data-active-slide-only")) return true;

    const slide = this.closest(".swiper-slide");
    const swiper = slide?.closest(".swiper");
    const activeSlide = swiper?.querySelector(".swiper-slide-active");

    if (!slide || !swiper || !activeSlide || slide === activeSlide) {
      return true;
    }

    const firstVisibleVideoSlide = Array.from(
      swiper.querySelectorAll(".swiper-slide-visible"),
    ).find((candidate) =>
      candidate.querySelector(
        "deferred-media[data-active-slide-only]",
      ),
    );

    return slide === firstVisibleVideoSlide;
  }

  refreshAutoplay() {
    const carouselIsActive = this.isActiveCarouselSlide();
    this.toggleAttribute(
      "data-carousel-autoplay-inactive",
      !carouselIsActive,
    );

    if (
      !this.autoplayIsIntersecting ||
      !this.isAutoplayAllowed() ||
      this.userPaused ||
      !carouselIsActive
    ) {
      this.cancelScheduledAutoplay();
      this.querySelector("video")?.pause();
      return;
    }

    const existingVideo = this.querySelector("video");
    if (this.hasAttribute("loaded") && existingVideo) {
      existingVideo.play().catch(() => {});
      return;
    }

    if (this.hasPriorityAutoplay()) {
      this.loadContent(false);
      return;
    }

    this.scheduleAutoplay();
  }

  observeForAutoplay() {
    if (
      !this.isConnected ||
      this.hasAttribute("data-defer-autoplay") ||
      this.autoplayObserver ||
      typeof IntersectionObserver !== "function"
    ) {
      return;
    }

    this.autoplayObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries.find((item) => item.target === this);
        this.autoplayIsIntersecting = Boolean(entry?.isIntersecting);
        this.refreshAutoplay();
      },
      { threshold: 0.25 },
    );
    this.autoplayObserver.observe(this);
  }

  scheduleAutoplay() {
    if (
      this.idleCallbackId !== null ||
      this.timeoutId !== null ||
      this.autoplayDelayId !== null ||
      this.pageLoadHandler
    ) {
      return;
    }

    if (document.readyState !== "complete") {
      this.pageLoadHandler = () => {
        this.pageLoadHandler = null;
        this.scheduleAutoplay();
      };
      window.addEventListener("load", this.pageLoadHandler, { once: true });
      return;
    }

    const load = () => {
      this.idleCallbackId = null;
      this.timeoutId = null;

      if (
        this.isConnected &&
        this.autoplayIsIntersecting &&
        this.isAutoplayAllowed() &&
        !this.userPaused &&
        this.isActiveCarouselSlide()
      ) {
        this.loadContent(false);
      }
    };

    this.autoplayDelayId = window.setTimeout(() => {
      this.autoplayDelayId = null;

      if (typeof window.requestIdleCallback === "function") {
        this.idleCallbackId = window.requestIdleCallback(load, {
          timeout: 3000,
        });
      } else {
        this.timeoutId = window.setTimeout(load, 1500);
      }
    }, 2000);
  }

  cancelScheduledAutoplay() {
    if (this.pageLoadHandler) {
      window.removeEventListener("load", this.pageLoadHandler);
      this.pageLoadHandler = null;
    }

    if (this.autoplayDelayId !== null) {
      window.clearTimeout(this.autoplayDelayId);
      this.autoplayDelayId = null;
    }

    if (this.idleCallbackId !== null) {
      window.cancelIdleCallback?.(this.idleCallbackId);
      this.idleCallbackId = null;
    }

    if (this.timeoutId !== null) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }

  stopAutoplayObserver() {
    this.cancelScheduledAutoplay();
    this.autoplayObserver?.disconnect();
    this.autoplayObserver = null;
    this.autoplayIsIntersecting = false;
  }

  cancelHlsReadyWait() {
    if (this.hlsReadyHandler) {
      window.removeEventListener("hls:ready", this.hlsReadyHandler);
      this.hlsReadyHandler = null;
    }

    if (this.hlsReadyTimeoutId !== null) {
      window.clearTimeout(this.hlsReadyTimeoutId);
      this.hlsReadyTimeoutId = null;
    }
  }

  destroyHls() {
    this.cancelHlsReadyWait();
    this.hls?.destroy?.();
    this.hls = null;
  }

  disconnectedCallback() {
    queueMicrotask(() => {
      if (this.isConnected) return;

      this.stopAutoplayObserver();
      this.destroyHls();
      this.setActiveVideo(null);
      this.poster?.removeEventListener("click", this.handlePosterClick);
      this.poster = null;
      this.playbackToggle?.removeEventListener(
        "click",
        this.handlePlaybackToggle,
      );
      this.playbackToggle = null;
      this.reduceMotionQuery?.removeEventListener(
        "change",
        this.handleReducedMotionChange,
      );
      this.reduceMotionQuery = null;
    });
  }

  loadContent(focus = true) {
    if (this.hasAttribute("loaded")) return;

    const template = this.querySelector("template");
    const templateContent = template?.content.firstElementChild;
    if (!templateContent) return;

    const content = document.createElement("div");
    content.appendChild(templateContent.cloneNode(true));

    const mediaElement = content.querySelector(
      "video, model-viewer, iframe",
    );
    if (!mediaElement) return;

    if (mediaElement.nodeName === "VIDEO") {
      this.setAttribute("data-video-hydrated", "");
      const posterImage = this.poster?.querySelector("img");
      const posterSource = posterImage?.currentSrc || posterImage?.src;
      if (posterSource) mediaElement.poster = posterSource;
    }

    this.setAttribute("loaded", "true");
    const deferredElement = this.appendChild(mediaElement);
    this.cancelScheduledAutoplay();

    this.dispatchEvent(
      new CustomEvent("deferred-media:loaded", {
        bubbles: true,
        detail: { media: deferredElement },
      }),
    );

    if (deferredElement.nodeName === "VIDEO") {
      this.setActiveVideo(deferredElement);
      const sources = deferredElement.querySelectorAll("source");
      let failedSourceCount = 0;
      let fallbackStarted = false;
      let autoplayStarted = false;

      const resetVideo = () => {
        this.destroyHls();
        this.setActiveVideo(null);
        this.removeAttribute("loaded");
        this.removeAttribute("data-video-hydrated");
        this.removeAttribute("data-autoplay-pending");
        this.removeAttribute("data-playing");
        deferredElement.remove();
      };

      const startAutoplay = () => {
        if (
          autoplayStarted ||
          (!deferredElement.hasAttribute("autoplay") && !focus) ||
          this.userPaused
        ) {
          return;
        }

        autoplayStarted = true;
        this.setAttribute("data-autoplay-pending", "");
        deferredElement.play().catch((error) => {
          autoplayStarted = false;
          this.removeAttribute("data-autoplay-pending");

          if (!this.userPaused && error?.name !== "AbortError") {
            this.setAttribute("data-autoplay-suppressed", "");
          }

          this.syncPlaybackControl();
        });
      };

      const loadFallback = () => {
        if (fallbackStarted) return;

        fallbackStarted = true;
        autoplayStarted = false;
        this.destroyHls();
        deferredElement.removeAttribute("src");

        sources.forEach((source) => {
          const deferredSource = source.getAttribute("data-src");

          source.addEventListener("error", () => {
            failedSourceCount += 1;

            if (failedSourceCount >= sources.length) resetVideo();
          });

          if (deferredSource) {
            source.src = deferredSource;
            source.removeAttribute("data-src");
          }
        });

        if (sources.length === 0) {
          deferredElement.addEventListener("error", resetVideo, {
            once: true,
          });
        }

        deferredElement.load();
        startAutoplay();
      };

      const hlsSource = deferredElement.dataset.hlsSrc;
      const resolveCappedHlsSource = async () => {
        const maxHeight = Number(deferredElement.dataset.maxVideoHeight);
        if (!hlsSource || maxHeight <= 0) return hlsSource;

        const response = await fetch(hlsSource, {
          credentials: "same-origin",
        });
        if (!response.ok) throw new Error("Unable to load HLS manifest");

        const lines = (await response.text()).split(/\r?\n/);
        let selectedSource = null;

        lines.forEach((line, index) => {
          if (!line.startsWith("#EXT-X-STREAM-INF:")) return;

          const resolution = line.match(/RESOLUTION=\d+x(\d+)/);
          const height = Number(resolution?.[1]);
          const sourcePath = lines
            .slice(index + 1)
            .find((candidate) => candidate && !candidate.startsWith("#"));

          if (
            !sourcePath ||
            height > maxHeight ||
            (selectedSource && height <= selectedSource.height)
          ) {
            return;
          }

          selectedSource = {
            height,
            url: new URL(sourcePath, new URL(hlsSource, document.baseURI))
              .href,
          };
        });

        return selectedSource?.url || hlsSource;
      };

      const loadNativeHls = async () => {
        try {
          const nativeSource = await resolveCappedHlsSource();
          if (!deferredElement.isConnected) return;

          deferredElement.addEventListener("error", loadFallback, {
            once: true,
          });
          deferredElement.src = nativeSource;
          deferredElement.load();
          startAutoplay();
        } catch (_error) {
          loadFallback();
        }
      };

      const initializeHls = () => {
        const HlsPlayer = window.Hls;
        if (!hlsSource || !HlsPlayer?.isSupported()) return false;

        this.cancelHlsReadyWait();
        this.hls = new HlsPlayer({
          startLevel: 0,
        });
        this.hls.on(HlsPlayer.Events.MANIFEST_PARSED, () => {
          const maxHeight = Number(deferredElement.dataset.maxVideoHeight);

          if (maxHeight > 0) {
            const cappedLevel = this.hls.levels.reduce(
              (selection, level, index) =>
                level.height <= maxHeight ? index : selection,
              -1,
            );

            if (cappedLevel >= 0) this.hls.autoLevelCapping = cappedLevel;
          }

          startAutoplay();
        });
        this.hls.on(HlsPlayer.Events.ERROR, (_event, data) => {
          if (data.fatal) loadFallback();
        });
        this.hls.loadSource(hlsSource);
        this.hls.attachMedia(deferredElement);
        return true;
      };

      const useAvailableHlsPlayer = () => {
        if (initializeHls()) return;

        if (
          deferredElement.canPlayType("application/vnd.apple.mpegurl")
        ) {
          loadNativeHls();
          return;
        }

        loadFallback();
      };

      const requestHlsPlayer = () => {
        const playerSource = deferredElement.dataset.hlsPlayerSrc;
        if (!playerSource) {
          this.hlsReadyHandler?.();
          return;
        }

        if (document.querySelector("script[data-hls-player]")) return;

        const script = document.createElement("script");
        script.src = playerSource;
        script.async = true;
        script.dataset.hlsPlayer = "";
        script.addEventListener(
          "error",
          () => {
            script.remove();
            this.hlsReadyHandler?.();
          },
          { once: true },
        );
        document.head.appendChild(script);
      };

      if (initializeHls()) {
        // HLS.js handles the adaptive stream and starts playback when ready.
      } else if (hlsSource && window.Hls) {
        useAvailableHlsPlayer();
      } else if (
        hlsSource &&
        deferredElement.canPlayType("application/vnd.apple.mpegurl")
      ) {
        loadNativeHls();
      } else if (hlsSource) {
        this.hlsReadyHandler = () => {
          this.cancelHlsReadyWait();
          if (!deferredElement.isConnected) return;

          useAvailableHlsPlayer();
        };
        window.addEventListener("hls:ready", this.hlsReadyHandler, {
          once: true,
        });
        this.hlsReadyTimeoutId = window.setTimeout(
          this.hlsReadyHandler,
          15000,
        );
        requestHlsPlayer();
      } else {
        loadFallback();
      }
    }

    if (focus) {
      if (this.playbackToggle && deferredElement.nodeName === "VIDEO") {
        this.syncPlaybackControl();
        this.playbackToggle.focus();
      } else {
        deferredElement.focus();
      }
    }
  }
}

if (!customElements.get("deferred-media")) {
  customElements.define("deferred-media", DeferredMedia);
}

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia(
        "(prefers-reduced-motion: reduce)",
      );
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true")
          this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true },
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener(
        "click",
        this.autoPlayToggle.bind(this),
      );
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) ||
      (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, fieldset"),
      (element) => {
        if (element.tagName === "SELECT") {
          return element.value;
        }
        if (element.tagName === "FIELDSET") {
          return Array.from(element.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value;
        }
      },
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === "SELECT" && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(
        `[data-selected-dropdown-swatch="${name}"] > .swatch`,
      );
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          swatchValue,
        );
        selectedDropdownSwatchValue.classList.remove("swatch--unavailable");
      } else {
        selectedDropdownSwatchValue.style.setProperty(
          "--swatch--background",
          "unset",
        );
        selectedDropdownSwatchValue.classList.add("swatch--unavailable");
      }
    } else if (tagName === "INPUT" && target.type === "radio") {
      const selectedSwatchValue = this.querySelector(
        `[data-selected-swatch-value="${name}"]`,
      );
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`,
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true,
      ),
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`,
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`,
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute("value");
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === "INPUT") {
        element.classList.toggle("disabled", !availableElement);
      } else if (element.tagName === "OPTION") {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace(
              "[value]",
              value,
            );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`,
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );

        const volumePricingDestination = document.getElementById(
          `Volume-${this.dataset.section}`,
        );
        const qtyRules = document.getElementById(
          `Quantity-Rules-${this.dataset.section}`,
        );
        const volumeNote = document.getElementById(
          `Volume-Note-${this.dataset.section}`,
        );

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination)
          volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden"),
          );
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden"),
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "hidden",
            inventorySource.innerText === "",
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`,
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          window.variantStrings.soldOut,
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(
      `Price-Per-Item-${this.dataset.section}`,
    );
    const volumeNote = document.getElementById(
      `Volume-Note-${this.dataset.section}`,
    );
    const volumeTable = document.getElementById(
      `Volume-${this.dataset.section}`,
    );
    const qtyRules = document.getElementById(
      `Quantity-Rules-${this.dataset.section}`,
    );

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

let mobileMenuDrawerController = null;

function initializeMobileMenuDrawer() {
  const drawer = document.getElementById("MobileMenuDrawer");
  const backdrop = document.getElementById("MobileMenuBackdrop");
  const openers = Array.from(document.querySelectorAll("[data-menu-drawer-open]"));
  if (!drawer || !backdrop || !openers.length) {
    if (mobileMenuDrawerController?.drawer.isConnected === false) {
      mobileMenuDrawerController.destroy();
      mobileMenuDrawerController = null;
    }
    return;
  }

  const controllerIsCurrent =
    mobileMenuDrawerController?.drawer === drawer &&
    mobileMenuDrawerController.openers.length === openers.length &&
    mobileMenuDrawerController.openers.every(
      (opener, index) => opener === openers[index],
    );
  if (controllerIsCurrent) return;

  mobileMenuDrawerController?.destroy();

  drawer.dataset.drawerInitialized = "true";
  const drawerSection = drawer.closest(".shopify-section");
  const activeDrawerBranch = drawerSection || drawer.parentElement;
  const closeButton = drawer.querySelector("[data-menu-drawer-close]");
  const closeControls = [
    ...drawer.querySelectorAll("[data-menu-drawer-close]"),
    backdrop,
  ];
  const inertedBackground = [];
  let activeOpener = null;
  let hideDrawerTimer = null;

  const setBackgroundInert = (shouldBeInert) => {
    if (!shouldBeInert) {
      inertedBackground.splice(0).forEach((element) => {
        element.removeAttribute("inert");
      });
      return;
    }

    let activeBranch = activeDrawerBranch;
    while (activeBranch && activeBranch !== document.body) {
      const parent = activeBranch.parentElement;
      if (!parent) break;

      Array.from(parent.children).forEach((element) => {
        if (element === activeBranch || element.hasAttribute("inert")) return;

        element.setAttribute("inert", "");
        inertedBackground.push(element);
      });
      activeBranch = parent;
    }
  };

  const closeDrawer = (restoreFocus = true) => {
    if (drawer.hidden) return;

    document.body.classList.remove("open-menu-drawer");
    drawer.setAttribute("aria-hidden", "true");
    drawer.setAttribute("inert", "");
    backdrop.hidden = true;
    openers.forEach((opener) => {
      opener.setAttribute("aria-expanded", "false");
      opener.setAttribute("aria-label", "Open main menu");
    });

    const openerToRestore = restoreFocus ? activeOpener : null;
    setBackgroundInert(false);
    removeTrapFocus(openerToRestore);
    drawer.querySelector("list-drawer-item")?.closeAllDisclosures();
    activeOpener = null;

    window.clearTimeout(hideDrawerTimer);
    hideDrawerTimer = window.setTimeout(() => {
      if (!document.body.classList.contains("open-menu-drawer")) {
        drawer.hidden = true;
      }
    }, 400);
  };

  const openDrawer = (opener) => {
    window.clearTimeout(hideDrawerTimer);
    activeOpener = opener;
    drawer.hidden = false;
    backdrop.hidden = false;
    drawer.removeAttribute("inert");
    drawer.setAttribute("aria-hidden", "false");
    openers.forEach((control) => {
      control.setAttribute("aria-expanded", "true");
      control.setAttribute("aria-label", "Close main menu");
    });
    setBackgroundInert(true);
    document.body.classList.add("open-menu-drawer");
    trapFocus(drawer, closeButton || drawer);
  };

  const openerHandlers = new Map();
  openers.forEach((opener) => {
    const handleOpen = () => {
      if (document.body.classList.contains("open-menu-drawer")) {
        closeDrawer();
      } else {
        openDrawer(opener);
      }
    };
    openerHandlers.set(opener, handleOpen);
    opener.addEventListener("click", handleOpen);
  });
  const handleClose = () => closeDrawer();
  closeControls.forEach((control) => control.addEventListener("click", handleClose));
  const handleEscape = (event) => {
    if (
      event.key === "Escape" &&
      document.body.classList.contains("open-menu-drawer")
    ) {
      event.preventDefault();
      closeDrawer();
    }
  };
  const handleResize = () => {
    if (
      window.innerWidth >= 1200 &&
      document.body.classList.contains("open-menu-drawer")
    ) {
      closeDrawer(false);
    }
  };
  document.addEventListener("keydown", handleEscape);
  window.addEventListener("resize", handleResize);

  mobileMenuDrawerController = {
    drawer,
    openers,
    destroy() {
      const drawerWasOpen = drawer.getAttribute("aria-hidden") === "false";
      window.clearTimeout(hideDrawerTimer);
      document.body.classList.remove("open-menu-drawer");
      drawer.setAttribute("aria-hidden", "true");
      drawer.setAttribute("inert", "");
      backdrop.hidden = true;
      openers.forEach((opener) => {
        opener.setAttribute("aria-expanded", "false");
        opener.setAttribute("aria-label", "Open main menu");
      });
      setBackgroundInert(false);
      if (drawerWasOpen) removeTrapFocus();
      openerHandlers.forEach((handler, opener) =>
        opener.removeEventListener("click", handler),
      );
      closeControls.forEach((control) =>
        control.removeEventListener("click", handleClose),
      );
      document.removeEventListener("keydown", handleEscape);
      window.removeEventListener("resize", handleResize);
      drawer.removeAttribute("data-drawer-initialized");
    },
  };
}

function initializeFooterDisclosures(scope = document) {
  const footers = scope.matches?.(".footer")
    ? [scope]
    : Array.from(scope.querySelectorAll?.(".footer") || []);

  footers.forEach((footer) => {
    if (footer.dataset.disclosuresInitialized === "true") return;

    footer.dataset.disclosuresInitialized = "true";
    const buttons = Array.from(
      footer.querySelectorAll("[data-footer-disclosure]"),
    );
    if (!buttons.length) return;

    const desktopQuery = window.matchMedia("(min-width: 1200px)");
    const syncToViewport = () => {
      buttons.forEach((button) => {
        const panel = document.getElementById(button.getAttribute("aria-controls"));
        if (!panel) return;

        if (desktopQuery.matches) {
          button.setAttribute("aria-expanded", "true");
          button.closest(".menu-section")?.classList.remove("opened");
          panel.hidden = false;
          panel.removeAttribute("inert");
          panel.setAttribute("aria-hidden", "false");
          panel.style.height = "";
        } else {
          setDisclosurePanelState(button, panel, false, false);
        }
      });
    };

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        if (desktopQuery.matches) return;

        const willExpand = button.getAttribute("aria-expanded") !== "true";
        buttons.forEach((otherButton) => {
          if (otherButton === button) return;
          const otherPanel = document.getElementById(
            otherButton.getAttribute("aria-controls"),
          );
          if (otherPanel) {
            setDisclosurePanelState(otherButton, otherPanel, false);
          }
        });

        const panel = document.getElementById(button.getAttribute("aria-controls"));
        if (panel) setDisclosurePanelState(button, panel, willExpand);
      });
    });

    desktopQuery.addEventListener("change", syncToViewport);
    footer.footerDisclosuresCleanup = () =>
      desktopQuery.removeEventListener("change", syncToViewport);
    syncToViewport();
  });
}

initializeMobileMenuDrawer();
initializeFooterDisclosures();
document.addEventListener("shopify:section:load", (event) => {
  initializeMobileMenuDrawer();
  initializeFooterDisclosures(event.target);
});
document.addEventListener("shopify:section:unload", (event) => {
  if (
    mobileMenuDrawerController &&
    (event.target.contains(mobileMenuDrawerController.drawer) ||
      mobileMenuDrawerController.openers.some((opener) =>
        event.target.contains(opener),
      ))
  ) {
    mobileMenuDrawerController.destroy();
    mobileMenuDrawerController = null;
  }

  const footer = event.target.matches?.(".footer")
    ? event.target
    : event.target.querySelector?.(".footer");
  footer?.footerDisclosuresCleanup?.();
});
